
{
  "familyId": "STU-PLANNEN",
  "questions": [
    {
      "id": "STU-PLANNEN-001",
      "familyId": "STU-PLANNEN",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_plannen",
      "questionType": "multiple_choice",
      "question": "Je moet een werkstuk maken over dieren. Wat is de beste eerste stap?",
      "options": ["Een plan maken: welke onderdelen wil je behandelen?", "Meteen beginnen met schrijven.", "Plaatjes zoeken op internet.", "Het werkstuk aan een vriend laten zien."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Plannen van een werkstuk",
            "content": "Begin altijd met een plan. Bedenk welke onderdelen je wilt behandelen en in welke volgorde. Daarna ga je informatie zoeken en schrijven.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "plannen_eerste_stap",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "stu.plannen.actie.voor.denken", "optionIndex": 1, "label": "Begint actie vóór denken/plannen" },
          { "id": "stu.plannen.materiaal.voor.structuur", "optionIndex": 2, "label": "Verzamelt materiaal vóór structuur te bepalen" },
          { "id": "stu.plannen.review.als.eerste.stap", "optionIndex": 3, "label": "Verwart review-fase met startfase" }
        ]
      },
      "feedback": {
        "explanationText": "De beste eerste stap is een plan maken. Bedenk welke onderdelen je wilt behandelen (bijv. soorten dieren, leefgebied, voedsel). Dan weet je wat je moet opzoeken en schrijven.",
        "solutionSteps": [
          "Stap 1: Plan maken (onderdelen bedenken)",
          "Stap 2: Informatie zoeken",
          "Stap 3: Schrijven",
          "Stap 4: Nakijken en verbeteren"
        ],
        "distractorExplanations": {
          "0": "Goed! Een plan maken is altijd de beste eerste stap.",
          "1": "Je dacht waarschijnlijk dat je meteen kunt beginnen. Maar zonder plan weet je niet wat je moet schrijven en vergeet je misschien onderdelen. Onthoud: eerst denken, dan doen.",
          "2": "Je dacht waarschijnlijk dat plaatjes zoeken een goede start is. Maar zonder plan weet je niet welke plaatjes je nodig hebt. Onthoud: eerst een plan, dan zoeken.",
          "3": "Je dacht waarschijnlijk dat je het werkstuk eerst moet laten zien. Maar je moet het eerst zelf maken! Laten zien is de laatste stap. Onthoud: plan → zoeken → schrijven → nakijken."
        }
      }
    },
    {
      "id": "STU-PLANNEN-002",
      "familyId": "STU-PLANNEN",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_plannen",
      "questionType": "multiple_choice",
      "question": "Je hebt 3 weken de tijd voor een project. Wanneer begin je het beste met plannen?",
      "options": ["In de eerste week", "In de laatste week", "De dag voor de deadline", "Plannen is niet nodig"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tijdplanning",
            "content": "Begin altijd zo vroeg mogelijk met plannen. Verdeel het werk over de beschikbare weken. Zo heb je genoeg tijd en voorkom je stress.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "plannen_tijdplanning",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.80,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.plannen.uitstelgedrag", "optionIndex": 1, "label": "Stelt plannen uit tot laatste week" },
          { "id": "stu.plannen.tijdsdruk.onderschat", "optionIndex": 2, "label": "Onderschat benodigde tijd radicaal" },
          { "id": "stu.plannen.nut.ontkend", "optionIndex": 3, "label": "Ontkent nut van plannen" }
        ]
      },
      "feedback": {
        "explanationText": "Begin in de eerste week met plannen. Verdeel het werk: week 1 = plan + informatie zoeken, week 2 = schrijven, week 3 = afmaken en nakijken. Zo heb je genoeg tijd.",
        "solutionSteps": [
          "Week 1: Plan maken + informatie zoeken",
          "Week 2: Schrijven en uitwerken",
          "Week 3: Afmaken, nakijken, verbeteren",
          "Vroeg beginnen = minder stress"
        ],
        "distractorExplanations": {
          "0": "Goed! Begin in de eerste week — dan heb je genoeg tijd voor alles.",
          "1": "Je dacht waarschijnlijk dat je in de laatste week nog genoeg tijd hebt. Maar dan moet je alles in één week doen — dat geeft stress en het resultaat wordt minder goed. Onthoud: verdeel het werk over alle weken.",
          "2": "Je dacht waarschijnlijk dat je de dag ervoor kunt beginnen. Maar een goed project kost meer dan één dag. Onthoud: begin vroeg, dan wordt het beter.",
          "3": "Je dacht waarschijnlijk dat plannen niet nodig is. Maar zonder plan vergeet je onderdelen en loop je vast. Onthoud: een goed plan bespaart uiteindelijk tijd."
        }
      }
    },
    {
      "id": "STU-PLANNEN-003",
      "familyId": "STU-PLANNEN",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_plannen",
      "questionType": "multiple_choice",
      "question": "Wat hoort NIET in een werkplanning?",
      "options": ["De namen van je klasgenoten", "De deadline", "De taakverdeling", "De stappen die je moet zetten"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wat staat in een werkplanning?",
            "content": "Een werkplanning bevat: de deadline, de stappen die je moet zetten, de taakverdeling (wie doet wat), en hoeveel tijd elke stap kost. Namen van klasgenoten zijn niet relevant.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "plannen_inhoud",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.77,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "stu.plannen.deadline.als.optioneel", "optionIndex": 1, "label": "Ziet deadline als optioneel onderdeel" },
          { "id": "stu.plannen.taakverdeling.weggelaten", "optionIndex": 2, "label": "Laat taakverdeling weg uit planning" },
          { "id": "stu.plannen.stappen.weggelaten", "optionIndex": 3, "label": "Laat stappen weg uit planning" }
        ]
      },
      "feedback": {
        "explanationText": "Een werkplanning bevat de deadline, de stappen, en de taakverdeling. De namen van je klasgenoten horen er niet in — tenzij je samenwerkt en het een taakverdeling is.",
        "solutionSteps": [
          "Werkplanning bevat: deadline ✓",
          "Werkplanning bevat: stappen ✓",
          "Werkplanning bevat: taakverdeling ✓",
          "Namen van klasgenoten: niet relevant ✗"
        ],
        "distractorExplanations": {
          "0": "Goed! Namen van klasgenoten horen niet in een werkplanning (tenzij het een groepsopdracht is met taakverdeling).",
          "1": "Je dacht waarschijnlijk dat de deadline er niet in hoort. Maar de deadline is juist het belangrijkste onderdeel — je plant terug vanaf de deadline. Onthoud: begin bij de deadline.",
          "2": "Je dacht waarschijnlijk dat de taakverdeling er niet in hoort. Maar als je samenwerkt, is het belangrijk om af te spreken wie wat doet. Onthoud: taakverdeling voorkomt verwarring.",
          "3": "Je dacht waarschijnlijk dat de stappen er niet in horen. Maar de stappen zijn de kern van je planning — ze vertellen je wat je moet doen. Onthoud: een planning zonder stappen is geen planning."
        }
      }
    },
    {
      "id": "STU-PLANNEN-004",
      "familyId": "STU-PLANNEN",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_plannen",
      "questionType": "multiple_choice",
      "question": "Je merkt halverwege dat je planning niet klopt — je hebt te weinig tijd voor het schrijven. Wat doe je?",
      "options": ["Je past je planning aan en maakt nieuwe afspraken.", "Je stopt met het project.", "Je levert het onaf in.", "Je doet alsof er niets aan de hand is."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Planning bijstellen",
            "content": "Een planning is een hulpmiddel, geen wet. Als het niet klopt, pas je het aan. Kijk wat je kunt schrappen of sneller kunt doen. Vraag eventueel om hulp.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "plannen_bijstellen",
      "variantIndex": 4,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.79,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.plannen.opgeven.bij.tegenslag", "optionIndex": 1, "label": "Geeft op bij planning-tegenslag" },
          { "id": "stu.plannen.onaf.accepteren", "optionIndex": 2, "label": "Accepteert onaf resultaat zonder aanpassing" },
          { "id": "stu.plannen.probleem.negeren", "optionIndex": 3, "label": "Negeert planning-probleem" }
        ]
      },
      "feedback": {
        "explanationText": "Als je planning niet klopt, stel je hem bij. Kijk wat je kunt aanpassen: misschien kun je een onderdeel korter maken of om hulp vragen. Een goede planner past zich aan.",
        "solutionSteps": [
          "Merk op dat de planning niet klopt",
          "Kijk wat je kunt aanpassen",
          "Maak nieuwe afspraken over tijd",
          "Ga verder met de aangepaste planning"
        ],
        "distractorExplanations": {
          "0": "Goed! Een planning aanpassen is slim — het laat zien dat je flexibel bent.",
          "1": "Je dacht waarschijnlijk dat je moet stoppen. Maar stoppen is zonde van het werk dat je al hebt gedaan. Onthoud: aanpassen is beter dan opgeven.",
          "2": "Je dacht waarschijnlijk dat onaf inleveren de enige optie is. Maar door je planning aan te passen, kun je misschien toch alles afkrijgen. Onthoud: eerst proberen aan te passen.",
          "3": "Je dacht waarschijnlijk dat je het probleem kunt negeren. Maar dan wordt het alleen maar erger. Onthoud: problemen vroeg aanpakken is altijd beter."
        }
      }
    },
    {
      "id": "STU-PLANNEN-005",
      "familyId": "STU-PLANNEN",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_plannen",
      "questionType": "ordering",
      "question": "Zet de stappen voor het maken van een werkstuk in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["Onderwerp kiezen en plan maken", "Informatie zoeken en verzamelen", "Tekst schrijven en uitwerken", "Nakijken en verbeteren"],
        "correctOrder": [0, 1, 2, 3]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stappen voor een werkstuk",
            "content": "1. Onderwerp kiezen en plan maken. 2. Informatie zoeken. 3. Tekst schrijven. 4. Nakijken en verbeteren. Onthoud: eerst denken, dan zoeken, dan schrijven, dan checken.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "plannen_stappen_ordering",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "De juiste volgorde: 1) Plan maken, 2) Informatie zoeken, 3) Schrijven, 4) Nakijken. Eerst denken, dan zoeken, dan doen, dan checken.",
        "solutionSteps": [
          "1. Onderwerp kiezen en plan maken",
          "2. Informatie zoeken en verzamelen",
          "3. Tekst schrijven en uitwerken",
          "4. Nakijken en verbeteren"
        ]
      }
    },
    {
      "id": "STU-PLANNEN-006",
      "familyId": "STU-PLANNEN",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_plannen",
      "questionType": "schedule_reading",
      "question": "Dani plant zijn werkstuk-week. Bekijk het planschema. Op welke dag schrijft hij de inleiding? Klik op het juiste vakje.",
      "options": [],
      "correctAnswer": "0-2",
      "data": {
        "schedule": {
          "columns": ["Ma", "Di", "Wo", "Do", "Vr"],
          "timeSlots": ["Taak"],
          "events": [
            { "row": 0, "col": 0, "content": "Onderwerp kiezen", "color": "blue" },
            { "row": 0, "col": 1, "content": "Informatie zoeken", "color": "orange" },
            { "row": 0, "col": 2, "content": "Inleiding schrijven", "color": "green" },
            { "row": 0, "col": 3, "content": "Hoofdstukken schrijven", "color": "green" },
            { "row": 0, "col": 4, "content": "Nakijken en verbeteren", "color": "red" }
          ]
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Schema lezen",
            "content": "Zoek de taak 'Inleiding schrijven' in het schema. Kijk dan bovenaan in welke kolom (dag) deze taak staat. Dat is op woensdag (Wo).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "plannen_schedule_reading",
      "variantIndex": 6,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "In het schema staat 'Inleiding schrijven' in de derde kolom. Bovenaan die kolom staat 'Wo' (woensdag). Dani schrijft zijn inleiding dus op woensdag.",
        "solutionSteps": [
          "Zoek de taak 'Inleiding schrijven'",
          "Kijk welke dag er bovenaan die kolom staat",
          "Klik op het vakje onder 'Wo'"
        ]
      }
    },
    {
      "id": "STU-PLANNEN-007",
      "familyId": "STU-PLANNEN",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_plannen",
      "questionType": "categorize",
      "question": "Sorteer de taken in de juiste fase van het maken van een werkstuk.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Plannen", "Zoeken", "Schrijven", "Nakijken"],
        "items": [
          { "text": "Onderwerp kiezen", "correctCategory": 0 },
          { "text": "Doelgroep bepalen", "correctCategory": 0 },
          { "text": "Boeken zoeken in bibliotheek", "correctCategory": 1 },
          { "text": "Internet doorzoeken", "correctCategory": 1 },
          { "text": "Inleiding maken", "correctCategory": 2 },
          { "text": "Conclusie schrijven", "correctCategory": 2 },
          { "text": "Spelfouten controleren", "correctCategory": 3 },
          { "text": "Bronnen checken", "correctCategory": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Fases van een werkstuk",
            "content": "Plannen: nadenken over wat je gaat doen. Zoeken: informatie verzamelen. Schrijven: de tekst maken. Nakijken: controleren op fouten en verbeteren.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "plannen_fases_categorize",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Onderwerp en doelgroep bepalen doe je vooraf (Plannen). Boeken en internet gebruik je om informatie te vinden (Zoeken). Inleiding en conclusie horen bij het maken van de tekst (Schrijven). Spelfouten en bronnen controleer je achteraf (Nakijken).",
        "solutionSteps": [
          "Bedenk bij elke taak wanneer je dit doet",
          "Vooraf nadenken = Plannen",
          "Informatie verzamelen = Zoeken",
          "Tekst maken = Schrijven",
          "Achteraf controleren = Nakijken"
        ]
      }
    },
    {
      "id": "STU-PLANNEN-008",
      "familyId": "STU-PLANNEN",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_plannen",
      "questionType": "matching",
      "question": "Koppel de plannings-term aan de juiste uitleg.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "Deadline", "right": "De einddatum waarop iets af moet zijn" },
          { "left": "Taakverdeling", "right": "Wie doet welk deel van het werk" },
          { "left": "Mijlpaal", "right": "Een belangrijk tussendoel" },
          { "left": "Bijstellen", "right": "De planning aanpassen als iets niet werkt" },
          { "left": "Prioriteit", "right": "Wat het belangrijkst is om eerst te doen" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Plannings-termen",
            "content": "Een deadline is de einddatum. Een mijlpaal is een tussendoel. Prioriteit is wat het belangrijkst is. Taakverdeling is wie wat doet. Bijstellen is aanpassen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "plannen_termen_matching",
      "variantIndex": 8,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Deadline = einddatum. Taakverdeling = wie doet wat. Mijlpaal = tussendoel. Bijstellen = aanpassen. Prioriteit = wat het belangrijkst is.",
        "solutionSteps": [
          "Lees de term en zoek de best passende uitleg",
          "Deadline heeft te maken met tijd/einddatum",
          "Prioriteit heeft te maken met belangrijkheid",
          "Bijstellen betekent veranderen/aanpassen"
        ]
      }
    }
  ]
}
